const selectors = {
  videoCard: '[data-video-card]',
  videoCardImage: '[data-video-card-image]',
}

const start = () =>
  gapi.client.init({
    apiKey: 'AIzaSyBsBJO1yww9D81Pni6ZHpcSrGC0h6KxhK0',
    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
  })

const getVideoThumbnail = (id) =>
  gapi.client
    .init({
      apiKey: 'AIzaSyBsBJO1yww9D81Pni6ZHpcSrGC0h6KxhK0',
      discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
    })
    .then(() =>
      gapi.client.youtube.videos.list({
        part: ['snippet,contentDetails,statistics'],
        id: [id],
      })
    )

const setVideoThumbnail = (imageNode, src) => {
  imageNode.setAttribute('src', src)
}

const isYoutubeVideo = (link) => !!link.match(/(youtu.?be)/gim)

const getYoutubeVideoID = (link) =>
  [/be\/(?<id>.*)\?/im, /\?v=(?<id>.*)/im]
    .map((regex) => ({
      regex,
      id: link.match(regex)?.groups.id,
    }))
    .find((item) => !!item.id)

const initVideoCard = (videoCard) => {
  if (!videoCard.dataset.videoCard) return
  if (!isYoutubeVideo(videoCard.dataset.videoCard)) return

  const { id } = getYoutubeVideoID(videoCard.dataset.videoCard)

  const image = videoCard.querySelector(selectors.videoCardImage)

  gapi.load('client', () => getVideoThumbnail(id).then(({ result }) => setVideoThumbnail(image, result.items[0].snippet.thumbnails.maxres.url)))
}

document.addEventListener('DOMContentLoaded', async function () {
  const videoCards = document.querySelectorAll(selectors.videoCard)

  videoCards?.forEach(initVideoCard)
})
